(() => {
  if (window.__writeFbwInitialized) {
    return;
  }

  window.__writeFbwInitialized = true;


  const getRootForForm = (form) => {
    if (!form) {
      return null;
    }

    const formId = form.getAttribute('id');

    if (!formId) {
      return null;
    }

    return Array.from(
      document.querySelectorAll('[data-fbw-root]')
    ).find((root) => {
      return root.dataset.fbwFormId === formId;
    }) || null;
  };


  const updateCardState = (card) => {
    if (!card) return;

    const checkbox = card.querySelector(
      '[data-fbw-checkbox]'
    );

    if (!checkbox) return;

    card.classList.toggle(
      'is-selected',
      checkbox.checked
    );
  };


  const updateVariant = (card) => {
    if (!card) return;

    const select = card.querySelector(
      '[data-fbw-variant]'
    );

    if (!select) return;

    const selectedOption =
      select.options[select.selectedIndex];

    if (!selectedOption) return;


    const priceElement =
      card.querySelector('[data-fbw-price]');

    const compareElement =
      card.querySelector('[data-fbw-compare-price]');

    const image =
      card.querySelector('.write-fbw__image');


    if (
      priceElement &&
      selectedOption.dataset.price
    ) {
      priceElement.textContent =
        selectedOption.dataset.price;
    }


    if (compareElement) {
      const comparePrice =
        selectedOption.dataset.comparePrice;

      if (comparePrice) {
        compareElement.textContent =
          comparePrice;

        compareElement.hidden = false;
      } else {
        compareElement.textContent = '';
        compareElement.hidden = true;
      }
    }


    if (
      image &&
      selectedOption.dataset.image
    ) {
      image.style.opacity = '0';

      window.setTimeout(() => {
        image.src =
          selectedOption.dataset.image;

        image.removeAttribute('srcset');

        image.style.opacity = '1';
      }, 100);
    }
  };


  const getSelectedProducts = (root) => {
    if (!root) {
      return [];
    }

    return Array.from(
      root.querySelectorAll(
        '[data-fbw-product]'
      )
    )
      .filter((card) => {
        const checkbox =
          card.querySelector(
            '[data-fbw-checkbox]'
          );

        return (
          checkbox &&
          checkbox.checked &&
          !checkbox.disabled
        );
      })

      .map((card) => {
        const select =
          card.querySelector(
            '[data-fbw-variant]'
          );

        const variantId =
          select
            ? select.value
            : card.dataset.defaultVariant;

        if (!variantId) {
          return null;
        }

        return {
          id: String(variantId),
          quantity: 1
        };
      })

      .filter(Boolean);
  };


  document.addEventListener(
    'change',
    (event) => {
      if (
        !event.target.matches?.(
          '[data-fbw-checkbox], [data-fbw-variant]'
        )
      ) {
        return;
      }


      if (
        event.target.matches(
          '[data-fbw-checkbox]'
        )
      ) {
        updateCardState(
          event.target.closest(
            '[data-fbw-product]'
          )
        );

        return;
      }


      updateVariant(
        event.target.closest(
          '[data-fbw-product]'
        )
      );
    }
  );


  document.addEventListener(
    'formdata',
    (event) => {
      const form = event.target;

      if (
        !(form instanceof HTMLFormElement)
      ) {
        return;
      }


      const root =
        getRootForForm(form);

      if (!root) {
        return;
      }


      if (
        root.dataset.fbwAddWithMain !==
        'true'
      ) {
        return;
      }


      const selectedProducts =
        getSelectedProducts(root);

      if (!selectedProducts.length) {
        return;
      }


      const formData =
        event.formData;

      const mainVariantId =
        formData.get('id');

      if (!mainVariantId) {
        return;
      }


      const parsedQuantity =
        parseInt(
          formData.get('quantity') || '1',
          10
        );

      const mainQuantity =
        Number.isFinite(parsedQuantity) &&
        parsedQuantity > 0
          ? parsedQuantity
          : 1;


      const sellingPlan =
        formData.get('selling_plan');


      const originalEntries =
        Array.from(
          formData.entries()
        );


      const propertyEntries =
        originalEntries.filter(
          ([key]) =>
            key.startsWith('properties[') &&
            key.endsWith(']')
        );


      formData.delete('id');
      formData.delete('quantity');
      formData.delete('selling_plan');
      formData.delete('product-id');


      propertyEntries.forEach(
        ([key]) => {
          formData.delete(key);
        }
      );


      formData.append(
        'items[0][id]',
        String(mainVariantId)
      );

      formData.append(
        'items[0][quantity]',
        String(mainQuantity)
      );


      if (sellingPlan) {
        formData.append(
          'items[0][selling_plan]',
          String(sellingPlan)
        );
      }


      propertyEntries.forEach(
        ([key, value]) => {
          const propertyName =
            key.slice(
              'properties['.length,
              -1
            );

          formData.append(
            `items[0][properties][${propertyName}]`,
            value
          );
        }
      );


      selectedProducts.forEach(
        (item, itemIndex) => {
          const index =
            itemIndex + 1;

          formData.append(
            `items[${index}][id]`,
            item.id
          );

          formData.append(
            `items[${index}][quantity]`,
            '1'
          );
        }
      );
    },
    true
  );
})();